import { paymentAndBalanceGraph, usagesGraph } from "./dispatch";

const initialState = {
  dashboardData: null,
  isLoading: false,
  error: null,
  subCategoryData: null,
  supplierTypeData: null,
  FCUnitData: null,
  ChargingNameData: null,
  ChargingTypeData: null,
  ChargingParameterData: null,
  ChargingUnitData: null,
  RateTypeData: null,
  StatusData: null,
  searchData: null,
  deleteData: null,
  editsearchData: null,
  allDropDownData:null,
  paymentAndBalanceGraph:null,
  usagesGraph:null,
  disconnectionAndReconnectionGraph:null,
  notificationGraph:null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_DASHBOARD_DATA_SUCCESS':
      return { ...state, dashboardData: action.payload, isLoading: false };
    case 'FETCH_SUB_CATEGORY_DATA_SUCCESS':
      return { ...state, subCategoryData: action.payload, isLoading: false };
    case 'FETCH_SUPPLIER_DATA_SUCCESS':
      return { ...state, supplierTypeData: action.payload, isLoading: false };
    case 'FETCH_UNIT_DATA_SUCCESS':
      return { ...state, FCUnitData: action.payload, isLoading: false };
    case 'FETCH_CHARGE_NAME_DATA':
      return { ...state, ChargingNameData: action.payload, isLoading: false };
    case 'FETCH_CHARGE_TYPE_DATA':
      return { ...state, ChargingTypeData: action.payload, isLoading: false };
    case 'FETCH_CHARGING_PARAMETER_DATA':
      return { ...state, ChargingParameterData: action.payload, isLoading: false };
    case 'FETCH_CHARGING_UNIT_DATA':
      return { ...state, ChargingUnitData: action.payload, isLoading: false };
    case 'FETCH_RATE_TYPE_DATA':
      return { ...state, RateTypeData: action.payload, isLoading: false };
    case 'FETCH_STATUS_DATA':
      return { ...state, StatusData: action.payload, isLoading: false };
    case 'FETCH_SEARCH_DATA':
      return { ...state, searchData: action.payload, isLoading: false };
    case 'FETCH_EDIT_SEARCH_DATA':
      return { ...state, editsearchData: action.payload, isLoading: false };
    case 'FETCH_DELETE_SEARCH_DATA':
      return { ...state, deleteData: action.payload, isLoading: false };
    case 'FETCH_ALL_DROPDOWN_DATA':
      return { ...state, allDropDownData: action.payload, isLoading: false };
    case 'FETCH_ALL_PAYMENTANDBALANCE_GRAPH':
      return { ...state, paymentAndBalanceGraph: action.payload, isLoading: false };
    case 'FETCH_ALL_USAGES_GRAPH':
      return { ...state, usagesGraph: action.payload, isLoading: false };
    case 'FETCH_ALL_DISCONNECTIONANDRECONNECTION_GRAPH':
      return { ...state, disconnectionAndReconnectionGraph: action.payload, isLoading: false };
    case 'FETCH_ALL_NOTIFICATION_GRAPH':
      return { ...state, notificationGraph: action.payload, isLoading: false };
    default:
      return state;
  }
};

export default dashboardReducer;